import { GameMode } from '../types';
import type { ModeDescription } from './types';
import { SUDDEN_DEATH_MODE } from './suddenDeath';
import { STANDARD_MODE } from './standard';
import { INFINITE_TIMED_MODE } from './infiniteTimed';
import { INFINITE_SCORE_MODE } from './infiniteScore';
import { QUESTION_SPRINT_MODE } from './questionSprint';
import { FIVE_FOR_FIVE_MODE } from './fiveForFive';
import { ROLLING_FIVE_MODE } from './rollingFive';
import { GRID_GAUNTLET_MODE } from './gridGauntlet';

export const MODE_DEFINITIONS: ModeDescription[] = [
  SUDDEN_DEATH_MODE,
  STANDARD_MODE,
  INFINITE_TIMED_MODE,
  INFINITE_SCORE_MODE,
  QUESTION_SPRINT_MODE,
  FIVE_FOR_FIVE_MODE,
  ROLLING_FIVE_MODE,
  GRID_GAUNTLET_MODE,
];

export const MODE_DESCRIPTIONS: Record<GameMode, Omit<ModeDescription, 'mode'>> =
  MODE_DEFINITIONS.reduce((acc, mode) => {
    acc[mode.mode] = {
      title: mode.title,
      description: mode.description,
      icon: mode.icon,
    };
    return acc;
  }, {} as Record<GameMode, Omit<ModeDescription, 'mode'>>);
